import React, { useRef, useEffect, forwardRef, memo } from 'react'

const TableCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
    const defaultRef = useRef();
    const resolvedRef = ref || defaultRef;
    
    useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
        <>
            <input type="checkbox" className="checkbox checkbox-sm checkbox-primary" ref={resolvedRef} {...rest} />
        </>
    );
});

// Export with memo to avoid unnecessary re-renders
export default memo(TableCheckbox, (prevProps, nextProps) => {
    // Ne pas mémoriser si la checkbox change d'état
    // Il est essentiel que la checkbox se mette à jour dès que checked change
    return (
        prevProps.indeterminate === nextProps.indeterminate &&
        prevProps.checked === nextProps.checked &&
        prevProps.disabled === nextProps.disabled
    );
});